import apiRequest from "../../apiCall";


const callCreateUserApi = async (id) => {
    return new Promise((resolve, reject) => {
      apiRequest('GET', `get-user/${id}`, null, true, true).then(res => {
        sessionStorage.setItem("createUserApi", JSON.stringify(res));
        resolve(res);
      
      })
          .catch(error => {
              console.error('Error calling home API:', error);
              reject(error);
          });
  });

}



export const AdmincreateUser = async (userdata) => {
    return new Promise((resolve, reject) => {
        apiRequest('POST', 'create-user', userdata,true, true).then(res => {
          sessionStorage.setItem("createUser", JSON.stringify(res));
          resolve(res);
        
        })
            .catch(error => {
                console.error('Error calling home API:', error);
                reject(error);
            });
    });
}


export const AdminupdateUser = async (userdata) => {
    return new Promise((resolve, reject) => {
        apiRequest('POST', 'update-admin-user', userdata,true, true).then(res => {
          console.log(res)
          sessionStorage.setItem("updateuser", JSON.stringify(res));
          resolve(res);
        
        })
            .catch(error => {
                console.error('Error calling home API:', error);
                reject(error);
            });
    });
}

export default callCreateUserApi;
